var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "absolute top-full inset-x-0 -mt-2 bg-white border shadow rounded-lg overflow-hidden z-20",
      attrs: {
        role: "region",
        "aria-label": "Search results",
        "aria-live": "polite"
      }
    },
    [
      _c(
        "ul",
        [
          _vm._l(_vm.$search.results, function(result) {
            return _c("li", { key: result.id }, [
              _c(
                "button",
                {
                  directives: [
                    { name: "stop-search", rawName: "v-stop-search" }
                  ],
                  staticClass: "w-full flex px-4 py-2 items-center border-b",
                  class: {
                    "bg-gray-300": _vm.$search.highlightedResult === result
                  },
                  attrs: {
                    type: "button",
                    title: _vm.resultButtonTitle(result)
                  },
                  on: {
                    click: function($event) {
                      return _vm.$search.openResult(result)
                    },
                    mouseenter: function($event) {
                      return _vm.$search.highlightResult(result)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "\n                        relative flex-shrink-0\n                        w-12 h-12 mr-2 flex items-center justify-center\n                        bg-gray-400 border border-gray-400\n                    "
                    },
                    [
                      _c("BaseIcon", {
                        staticClass: "w-5 h-5 text-gray-600",
                        attrs: { name: "photo" }
                      }),
                      result.posterUrl
                        ? _c("div", {
                            staticClass:
                              "bg-cover bg-center absolute inset-0 w-full h-full",
                            style: {
                              backgroundImage: "url('" + result.posterUrl + "')"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-col items-start overflow-hidden"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center max-w-full mb-1" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-base font-semibold tracking-wide mr-2 truncate"
                            },
                            [_vm._v(" " + _vm._s(result.title) + " ")]
                          ),
                          result.exists()
                            ? _c("BaseIcon", {
                                staticClass: "flex-shrink-0 w-4 h-4",
                                class: {
                                  "text-green-600": result.watched,
                                  "text-blue-600": !result.watched
                                },
                                attrs: {
                                  name: result.watched ? "checkmark" : "time"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("span", { staticClass: "text-sm text-gray-700" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              result.releaseDate
                                ? result.releaseDate.getFullYear()
                                : "-"
                            ) +
                            " "
                        )
                      ])
                    ]
                  )
                ]
              )
            ])
          }),
          _vm.$search.searching
            ? _c(
                "li",
                {
                  staticClass:
                    "flex items-center justify-center h-16 text-primary-500"
                },
                [_c("LoadingDots")],
                1
              )
            : _vm.$search.results.length === 0
            ? _c(
                "li",
                { staticClass: "flex items-center justify-center h-16" },
                [_c("span", [_vm._v("Not results found.")])]
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }